import { render, staticRenderFns } from "./PartnershipD.vue?vue&type=template&id=f7916030&scoped=true"
import script from "./PartnershipD.vue?vue&type=script&lang=js"
export * from "./PartnershipD.vue?vue&type=script&lang=js"
import style0 from "./PartnershipD.vue?vue&type=style&index=0&id=f7916030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7916030",
  null
  
)

export default component.exports